import { SVGProps } from 'react';

export const ImageIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      fill="none"
      height="36"
      viewBox="0 0 41 36"
      width="36"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.875 7.375C10.7656 7.375 9.125 9.09375 9.125 11.125C9.125 13.2344 10.7656 14.875 12.875 14.875C14.9062 14.875 16.625 13.2344 16.625 11.125C16.625 9.09375 14.9062 7.375 12.875 7.375ZM35.9219 0.5H5.92188C3.1875 0.5 0.921875 2.76562 0.921875 5.5V30.5C0.921875 33.3125 3.1875 35.5 5.92188 35.5H35.9219C38.6562 35.5 40.9219 33.3125 40.9219 30.5V5.5C40.9219 2.76562 38.7344 0.5 35.9219 0.5ZM37.1719 30.0312L26.4688 15.5C26.2344 15.1094 25.8438 14.875 25.375 14.875C24.8281 14.875 24.4375 15.1094 24.125 15.5L15.8438 26.75L12.9531 23.1562C12.6406 22.8438 12.25 22.6094 11.7812 22.6094C11.3125 22.6094 10.9219 22.8438 10.6094 23.1562L4.75 30.5L4.67188 5.5C4.67188 4.875 5.29688 4.25 5.92188 4.25H35.9219C36.625 4.25 37.1719 4.875 37.1719 5.5V30.0312Z"
        fill="#D9D9D9"
      />
    </svg>
  );
};

export default ImageIcon;
